import * as Yup from "yup";

const OBJECT_ID_REGEX = /^[a-f\d]{24}$/i;

export const getClientValidationSchema = (
  isEditing = false,
  hasExistingLogo = false,
) =>
  Yup.object({
    name: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
      .required("Client name is required"),

    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),

    phone: Yup.string()
      .transform((value) => (value === "" ? undefined : value))
      .optional()
      .matches(/^[0-9]{10,15}$/, "Invalid phone number"),

    country: Yup.string().required("Country is required"),

    
    logo:
      isEditing && hasExistingLogo
        ? Yup.mixed().nullable()
        : Yup.mixed().required("Client logo is required"),
  });

export const clientValidationSchema = getClientValidationSchema();
